import { React, useEffect, useState } from "react";
import axios from 'axios';
import LangChange from "./LangChange";
export default function Constitution() {
    // const { t } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("lang"));
    const [constitution, setConstitution] = useState({})
    const getConstitutionEnglishData = async () => {
        //http://localhost:3001/constitution
        //https://n2m4hmwxiw.us-east-1.awsapprunner.com/constitution
        // axios.post('http://localhost:3001/constitution')
        //     .then(res => {
        //         console.log('Arabic response', res.data);
        //     }).catch(error => {
        //         console.error('Error fetching data:', error.message);
        //     });
        axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/constitution')
            .then(res => {
                setConstitution(res.data.message);
                console.log('response', res.data.message);
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
    }
    const getConstitutionArabicData = async () => {
        //http://localhost:3001/constitution
        // https://n2m4hmwxiw.us-east-1.awsapprunner.com/constitution
        // axios.post('http://localhost:3001/constitution/ar')
        //     .then(res => {
        //        console.log('Arabic response', res.data);
        //     }).catch(error => {
        //         console.error('Error fetching data:', error.message);
        //     });
        axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/constitution/ar')
            .then(res => {
                setConstitution(res.data.message);
                console.log('response', res.data);
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
    }
    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("lang"));
        console.log('current language is', currentLanguage);
        if (currentLanguage === "en") {
            getConstitutionEnglishData();
        } else {
            getConstitutionArabicData();
        }


    }, [currentLanguage]);
    useEffect(() => {
        // console.log('use effect local storage', localStorage.getItem("lang"));
        if (currentLanguage === "en") {
            getConstitutionEnglishData();
        } else {
            getConstitutionArabicData();
        }
    }, [currentLanguage]);
    const dynamicStyle = {
        'textAlign': localStorage.getItem("lang") === "ar" ? 'right' : 'left',
        'listStyleType': localStorage.getItem("lang") === "ar" ? 'none' : null,
        'paddingLeft': '5px',
        'paddingRight': '5px'
    }
    return (
        <div style={dynamicStyle}>
            <LangChange />
            {
                constitution.length > 0 && constitution.map((item, index) => (
                    <div key={index} className="divData">
                        <h3 style={dynamicStyle}>{item.Name}</h3>
                        <p style={dynamicStyle}>{
                            item?.Info ?
                                item?.Info.split(".").map((temp, index) => (
                                    <li style={dynamicStyle} key={index}>{temp}</li>))
                                : item?.Info
                        }</p>
                    </div>
                ))
            }
        </div >);
}